import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CloseIconWhite from './close_icon_white.svg';
import CloseIcon from './close_icon_black.svg';
import './Logout.scss';

/**
 * Logout control
 * @class Logout
 * @extends {Component}
 */
class Logout extends Component {
  static propTypes = {
    /** Type of close icon to show */
    type: PropTypes.string,
    /** Function executed when the logout button is clicked */
    onLogoutClick: PropTypes.func,
  };
  static defaultProps = {
    type: 'black',
    onLogoutClick: () => void 0,
  };

  render() {
    return (
      <div className='text-center logout-topRight'>
        <button
          id='Logout_link'
          className='btn btn-link btn-link-logout'
          onClick={this.props.onLogoutClick}
        >
          <img src={this.props.type === 'white'? CloseIconWhite : CloseIcon} alt='Close'/>
        </button>
      </div>
    );
  }
}

export default Logout;
